import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObserversModule } from '@angular/cdk/observers';
import { PhxFilterRowComponent } from './phx-filter-row.component';
import { PhxButtonModule } from '../button/phx-button.module';
import { PhxSortItemDirective } from './phx-sort-item.directive';
import { PhxHideOnMobileDirective } from './phx-hide-on-mobile.directive';
import { PhxSkeletonModule } from './../skeleton/phx-skeleton.module';
import { PhxTileModule } from '../tile/phx-tile.module';
import { PhxIconModule } from '../icon/icon.module';
import { PhxDropdownModule } from '../dropdown/phx-dropdown.module';
import { PhxBadgeModule } from '../badge/phx-badge.module';
import { PhxLinkModule } from '../link/phx-link.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';

@NgModule({
  declarations: [PhxFilterRowComponent, PhxSortItemDirective, PhxHideOnMobileDirective],
  imports: [CommonModule, ObserversModule, PhxButtonModule, PhxSkeletonModule, PhxTileModule, PhxIconModule, PhxDropdownModule, PhxBadgeModule, PhxLinkModule, PhxTranslationsRootModule],
  exports: [PhxFilterRowComponent, PhxSortItemDirective, PhxHideOnMobileDirective],
  providers: [],
})
export class PhxFilterRowModule {}
